<template>
  <FlexRow :space="4">
    <JobSearchConditions v-model="searchConditions" @enter="onSearch"/>
    <Button color="primary" fab class="mt-9" @click="onSearch">
      <v-icon>mdi-magnify</v-icon>
    </Button>
  </FlexRow>
</template>

<script>
import JobSearchConditions from "@/components/organisms/JobSearchConditions";
import ApiMixin from "@/ApiMixin";
import FlexRow from "../atoms/FlexRow";
import Button from "../atoms/Button";

export default {
  mixins: [ApiMixin],
  name: "JobSearchForm",
  components: {Button, FlexRow, JobSearchConditions},
  props: {
    conditions: Object
  },
  data() {
    return {
      searchConditions: {
        jobType: "regular"
      }
    }
  },
  methods: {
    onSearch () {
      this.$router.push({
        name: "JobSearch",
        query: this.searchConditions
      })
      this.$emit('search', this.searchConditions)
    }
  },
  watch: {
    conditions: {
      handler() {
        this.searchConditions = this.conditions
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
